/* eslint-disable no-script-url */
/*
 * Dependencies
 */

// Vendors
import React, { useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';

// Components
import Ellipsis from 'components/ellipsis';
import Dialog from 'components/dialog';
import Alert from 'components/alert';

// Styles
import { Root, Content, Logo, LogoImg, Identity, Name, Address, AddressLink, Categories, Features, Badge, Links, Link, Close, Section, H2, Item, Button, DeliverooIcon } from './styles.js';

//
const PLACEHOLDER_SRC = 'data:image/png;base64,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';

/*
 *
 */
export function Card ({ name='', address='', logo_src='', categories=[], takeaway=false, delivery=false, phone=null, website=null, delivery_details={}, takeaway_details={} }) {

	const intl = useIntl();
	const [showModal, setShowModal] = useState(false);
	const has_order = (Object.entries(delivery_details.partners || {}).some(([k, v]) => !!v.enabled) || Object.entries(takeaway_details.partners || {}).some(([k, v]) => !!v.enabled)) || phone;
	const encodedAddress = encodeURIComponent(address)

	return (
		<React.Fragment>
			<Root>
				<Content>
					<Logo>
						{logo_src ? (
							<LazyLoadComponent>
								<LogoImg src={logo_src} />
							</LazyLoadComponent>
						) : (
							<LogoImg src={PLACEHOLDER_SRC} />
						)}
					</Logo>
					<Identity>
						<Name><Ellipsis>{name}</Ellipsis></Name>
						<Address>
							<Ellipsis>
								<AddressLink 
									href={`https://www.google.be/maps/place/${encodedAddress}`} 
									rel="noopener noreferrer" 
									target="_blank"
									onClick={e => {
							        // Lets track that custom click
							        trackCustomEvent({
							          // string - required - The object that was interacted with (e.g.video)
							          category: "Link",
							          // string - required - Type of interaction (e.g. 'play')
							          action: "Get Directions",
							          // string - optional - Useful for categorizing events (e.g. 'Spring Campaign')
							          label: name
							        })
							      }}>{address}</AddressLink>
							</Ellipsis>
						</Address>
						<Categories><Ellipsis>{categories}</Ellipsis></Categories>
					</Identity>
					<Features>
						<Badge active={!!takeaway}>{intl.formatMessage({ id: 'component.card.takeaway' })}</Badge>
						<Badge active={!!delivery}>{intl.formatMessage({ id: 'component.card.delivery' })}</Badge>
					</Features>
				</Content>
				<Links>
					<Link as="button" onClick={() => setShowModal(true)} disabled={!has_order}>
						{intl.formatMessage({ id: 'component.card.order' })}
					</Link>
					<Link 
						as={website ? 'a' : 'div'} 
						href={website ? website : null} 
						target={website ? '_blank' : null} 
						disabled={!website}
						onClick={e => {
					        // Lets track that custom click
					        trackCustomEvent({
					          // string - required - The object that was interacted with (e.g.video)
					          category: "Button",
					          // string - required - Type of interaction (e.g. 'play')
					          action: "Go to Website",
					          // string - optional - Useful for categorizing events (e.g. 'Spring Campaign')
					          label: name
					        })
					      }}>
						{intl.formatMessage({ id: 'component.card.website' })}
					</Link>
				</Links>
			</Root>
			<Dialog isOpen={showModal} title={intl.formatMessage({ id: 'component.card.modal.title' }, { businessName: name })} onRequestClose={() => setShowModal(false)}>
				<Dialog.Content>
					{phone && (
						<Section>
							<H2>{intl.formatMessage({ id: 'component.card.modal.phone_orders' })}</H2>
							<Item>
								<Button 
									href={`tel:${phone}`}
									onClick={e => {
								        // Lets track that custom click
								        trackCustomEvent({
								          // string - required - The object that was interacted with (e.g.video)
								          category: "Order Button",
								          // string - required - Type of interaction (e.g. 'play')
								          action: "Phone",
								          // string - optional - Useful for categorizing events (e.g. 'Spring Campaign')
								          label: name
								        })
								      }}>
									{phone}
								</Button>
							</Item>
						</Section>
					)}

					{(Object.entries(delivery_details.partners || {}).some(([k, v]) => !!v.enabled) || Object.entries(takeaway_details.partners || {}).some(([k, v]) => !!v.enabled)) && (
						<Section>
							<H2>{intl.formatMessage({ id: 'component.card.modal.online_orders' })}</H2>
							{[].concat(
								Object.entries(delivery_details.partners || {}),
								Object.entries(takeaway_details.partners || {})
							)
								.filter(([k, v]) => !!v.enabled)
								.map(([k, v]) => ({
									...v,
									partner: {
										...v.partner,
										formatted_name: (
											v.partner.name === 'other' ? (
												'zzzzz'
											) : (
												intl.formatMessage({ id: `partners.${v.partner.name}` })
											)
										)
									}
								}))
								.sort((a, b) => a.partner.formatted_name.localeCompare(b.partner.formatted_name))
								.map(item => (
									<Item key={item.partner.name}>
										{item.partner.name === 'deliveroo'
											? (
												<Alert 
													type="success"
													emoji="🎁">
													<p>
														<FormattedMessage
															id="partners.deliveroo.coupon.newusers"
															values={{
																strong: (...chunks) => (
																	<strong>{chunks}</strong>
																)
															}}
														/>
													</p>
												</Alert>
											) : null
										}
										<Button 
											href={item.partner.name === 'deliveroo' ? `${item.url}?utm_source=CentralApp&utm_medium=affiliate`: item.url} 
											target="_blank" 
											rel="noopener noreferrer" 											
											onClick={e => {
										        // Lets track that custom click
										        trackCustomEvent({
										          // string - required - The object that was interacted with (e.g.video)
										          category: "Order Button",
										          // string - required - Type of interaction (e.g. 'play')
										          action: item.partner.name,
										          // string - optional - Useful for categorizing events (e.g. 'Spring Campaign')
										          label: name
										        })
										      }}>
											{item.partner.name === 'deliveroo' ? (
												<DeliverooIcon>
													<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 100 100">
														<path fill="#fff" d="M16.3945312,81.6943359l54.3291016,11.5488281l12.4248047-27.9072266l5.9160156-56.2885742L67.2714844,6.7568359
														l-4.0068359,38.1357422l-6.8339844-32.1499023l-21.4316406,4.5561523l6.8330078,32.1499023L10.9355469,56.015625
														L16.3945312,81.6943359z M59.5263672,60.8837891c0.0830078-0.5898438,0.3173828-1.1425781,0.6875-1.609375
														c0.5068359-0.640625,1.3496094-1.4794922,2.3242188-1.5019531c1.5869141-0.0429688,2.9550781,0.6699219,3.7236328,1.9570312
														c0.7734375,1.2851562,0.3876953,2.7021484-0.4287109,4.1181641c-0.8144531,1.4140625-2.9492188,1.6025391-5.0517578,0.5742188
														C59.3632812,63.7255859,59.3710938,61.9589844,59.5263672,60.8837891z M44.2578125,57.7744141
														c0.4423828-1.7041016,2.5273438-1.9580078,3.5722656-1.9755859c0.3945312-0.0087891,0.7832031,0.0722656,1.1445312,0.2353516
														c0.7363281,0.3320312,1.9863281,1.0478516,2.2382812,2.1376953c0.3662109,1.5664062,0.0136719,2.8808594-1.1074219,3.90625
														c-1.1220703,1.0263672-2.6035156,0.9355469-4.1738281,0.4082031C44.3613281,61.9677734,43.6650391,60.0673828,44.2578125,57.7744141
														z"/>
													</svg>
												</DeliverooIcon>
												) : null} 
											<span>{item.partner.name === 'other' ? (
												intl.formatMessage({ id: 'partners.other' })
											) : (
												intl.formatMessage({ id: `component.card.partner.cta` }, { partnerName : item.partner.formatted_name })
											)}</span>
										</Button>
									</Item>
							))}
						</Section>
					)}
				</Dialog.Content>
				<Dialog.Footer>
					<Close onClick={() => setShowModal(false)}>
						{intl.formatMessage({ id: 'component.card.modal.close' })}
					</Close>
				</Dialog.Footer>
			</Dialog>
		</React.Fragment>
	);
}

export default Card;